import React from 'react';
import {useWindowDimensions, View} from 'react-native';
import {Banner, Divider, Portal, useTheme} from 'react-native-paper';
import Chat from '../../contacts/chat';
import Encoderproject from '../../encoder/encoderproject';
import {MobileLayersBanner} from './mobilelayersbanner';
import {useAppSelector} from '../../../store/hooks';
export function MobileBanner({projectId, routeParams}) {
  const {width, height} = useWindowDimensions();
  let dynamicHeight = height / 2;
  const hasSelection =
    routeParams.encoder !== undefined ||
    routeParams.chatId !== undefined;
  const isUploadInProgress = useAppSelector(
    state => state.upload.isUploadInProgress,
  );
  const hasMedia = useAppSelector(
    state => state.media.currentMediaId,
  );
  const isRendering = useAppSelector(
    state => state.editor.isRendering,
  );
  const isRenderingError = useAppSelector(
    state => state.editor.ffmpegError,
  );
  if (isRendering) dynamicHeight -= 50;
  if (isRenderingError) dynamicHeight -= 200;
  if (isUploadInProgress) dynamicHeight -= 50;
  if (hasMedia) dynamicHeight -= height / 4;

  return (
    <View
      style={{
        margin: 0,
        padding: 0,
        height: dynamicHeight,
        display: 'flex',
        backgroundColor: 'black',
      }}>
      <Divider />
      {hasSelection && (
        <View
          style={{
            width: '100%',
            height: dynamicHeight + 100,
            display: 'flex',
            paddingBottom: 100,
          }}
          key={'third_container'}>
          {routeParams?.encoder && (
            <Encoderproject params={routeParams} />
          )}
          {routeParams?.chatId && (
            <Chat
              isEmbed={true}
              params={routeParams}
              height={dynamicHeight + 100}
            />
          )}
        </View>
      )}
      <MobileLayersBanner
        projectId={projectId}
        width={width}
        height={dynamicHeight}
        hasSelection={hasSelection}
      />
    </View>
  );
}
